<template>
  <form
    ref="form"
    data-url="/accreditationtechnical/decisionDirectorFile/directorTechnicalReport"
    :class="{ 'loading-opacity': preloader }"
    enctype="multipart/form-data"
  >
  
    <div class="row">
      <div class="col-12">
        <legend class="col-form-label text-primary pt-0 mb-3">
          <h5>Evaluaciones</h5>
        </legend>
      </div>
      <div class="col-12">
        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th scope="col">Expediente</th>
              <th scope="col">Tipo</th>
              <th scope="col">Código</th>
              <th scope="col">Estado</th>
              <th scope="col" class="text-center" style="width: 10%">
                Documento
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(value, key) in evaluations" :key="key">
              <td class="align-middle">
                {{ value.accreditation_applications.record }}
              </td>
              <td class="align-middle">
                <p v-if="value.type == 'E'">Evaluación</p>
                <p v-if="value.type == 'T'">Testificación</p>
              </td>
              <td class="align-middle">{{ value.code }}</td>
              <td class="align-middle">
                {{ value.status.name }}
                <small class="text-success" v-if="value.status.code == 607"
                  >(Finalizado)</small
                >
                <small class="text-danger" v-if="value.status.code != 607"
                  >(En proceso)</small
                >
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openModal(value)"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="col-12">
        <legend class="col-form-label text-primary pt-0 mb-3">
          <h5>Documentos</h5>
        </legend>
        <table class="table table-sm table-striped" v-if="docs">
          <thead>
            <tr>
              <th scope="col">TIPO</th>
              <th scope="col">NOMBRE</th>
              <th scope="col">FECHA</th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="align-middle">Solicitud de acreditación firmada</td>
              <td class="align-middle">
                {{ docs.request_signed.user.full_name }}
              </td>
              <td class="align-middle">
                {{ docs.request_signed.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(docs, 'request_signed')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <tr v-if="docs.request_signed">
              <td class="align-middle">
                Anexos de la Solicitud de Acreditación
              </td>
              <td class="align-middle">
                {{
                  docs.user
                    ? `${docs.user.first_name} ${docs.user.last_name}`
                    : ""
                }}
              </td>
              <td class="align-middle">
                {{ docs.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <a
                  class="btn btn-success"
                  :href="`/accreditations/applications/${docs.id}?tab=Anexos`"
                  target="_blank"
                  ><app-icon name="file" /> {{ $t("view") }}</a
                >
              </td>
            </tr>
            <tr>
              <td class="align-middle">
                Registro de Ingreso de solicitud de acreditación y acuse recibo
              </td>
              <td class="align-middle">
                {{ docs.receipt_return_report.user.full_name }}
              </td>
              <td class="align-middle">
                {{ docs.receipt_return_report.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(docs, 'receipt_return_report')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <tr>
              <td class="align-middle">
                Informe de la comisión de acreditación
              </td>
              <td class="align-middle">
                {{ docs.suspended_decision_report.user.full_name }}
              </td>
              <td class="align-middle">
                {{ docs.suspended_decision_report.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(docs, 'suspended_decision_report')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <tr>
              <td class="align-middle">
                Informe Técnico de Análisis de Expediente y de Toma de Decisión
              </td>
              <td class="align-middle">
                {{ docs.technical_file_analysis_report.user.full_name }}
              </td>
              <td class="align-middle">
                {{ docs.technical_file_analysis_report.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(docs, 'technical_file_analysis_report')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>

            <tr>
              <td class="align-middle">
                Anexo de plan de mantenimiento
              </td>
              <td class="align-middle">
                {{ docs.maintenance_plan.user.full_name }}
              </td>
              <td class="align-middle">
                {{ docs.maintenance_plan.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(docs, 'maintenance_plan')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      
    </div>

    <div class="row" v-if="showFile">
      <div class="col-6">
        <div class="form-group">
          <label>Borrador del Informe Técnico del Director de Área: <strong class="text-danger">*</strong></label>
          <app-input
            type="file"
            :label="inputs.file ? inputs.file.name : $t('upload_your_file')"
            v-model="inputs.file"
            :required="true"
            v-if="!inputs.director_technical_report"
          />
          <div class="mt-2">
            <button
              type="submit"
              class="btn btn-success"
              @click.prevent="openTab(inputs, 'director_technical_report')"
              v-if="inputs.director_technical_report"
            >
              <app-icon name="file" />
              {{ $t("view") }}
            </button>

            <button
              type="submit"
              class="btn btn-danger"
              @click.prevent="openDeleteModal('director_technical_report')"
              v-if="inputs.director_technical_report"
            >
              <app-icon name="trash-2" />
              {{ $t("delete") }}
            </button>
          </div>
        </div>
      </div>

      <!-- Scope 607 -->
      <!-- <div class="col-6">
        <div class="form-group">
          <label>Alcance de acreditación: <strong class="text-danger">*</strong></label>
          <app-input
            type="file"
            :label="inputs.file_1 ? inputs.file_1.name : $t('upload_your_file')"
            v-model="inputs.file_1"
            :required="true"
            v-if="!inputs.scope607"
          />
          <div class="mt-2">
            <button
              type="submit"
              class="btn btn-success"
              @click.prevent="openTab(inputs, 'scope607')"
              v-if="inputs.scope607"
            >
              <app-icon name="file" />
              {{ $t("view") }}
            </button>

            <button
              type="submit"
              class="btn btn-danger"
              @click.prevent="openDeleteModal('scope607')"
              v-if="inputs.scope607"
            >
              <app-icon name="trash-2" />
              {{ $t("delete") }}
            </button>
          </div>
        </div>
      </div> -->
    </div>

    <div class="row" v-if="showFile">
      <div class="col-12 mt-3">
        <button
          type="submit"
          class="btn btn-primary mr-2"
          @click.prevent="submit"
        >
          {{ $t("save") }}
        </button>
      </div>
    </div>

    <director-area-modal
      v-if="isAddEditModalActive"
      :selected-url="selectedUrl"
      @close-modal="closeAddEditModal"
    />

    <app-confirmation-modal
      v-if="deleteModal"
      modal-id="delete"
      @confirmed="confirmed"
      @cancelled="cancelled"
      title="Confirmación"
      message="¿Desea eliminar este archivo?"
    />
  </form>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import * as actions from "../../../apiUrl";
import { axiosGet } from "../../../../../../../../resources/js/app/helpers/AxiosHelper";
export default {
  mixins: [FormMixin],

  data() {
    return {
      isAddEditModalActive: false,
      deleteConfirmationModalActive: false,
      preloader: false,
      inputs: {},
      deleteModal: false,
      selected: "",
      evaluations: "",
      report:"",
      showFile:true,
      docs: ""
    };
  },

  filters: {
    dateFormat: function (value) {
      return moment(value).format("YYYY-MM-DD HH:mm");
    },
  },

  computed: {
    evalTest() {
      return this.inputs;
    },
  },

  watch: {
    "$store.state.evaluatorReview.evalTest": function () {
      this.loadForm();
    },
  },

  created() {
    this.loadForm();
    this.data();
    this.dataInfo();
  },

  methods: {
    beforeSubmit() {
      this.preloader = true;
    },

    dataInfo() {
      let url = `/accreditationReview/decision/areaDirectorReport/show?accAppId=${this.$store.state.evaluatorReview.accreditationId}`;
      this.axiosGet(url).then((response) => {
        this.docs = response.data;
      });
    },

    data() {
      let url = `${actions.TECHNICAL_ANALYSIS_REPORT}/decisionDirectorFile/directorTechnicalReport/evaluationList/${this.$store.state.evaluatorReview.accreditationId}`;
      this.axiosGet(url).then((response) => {
        this.evaluations = response.data.evaluations;
      });
    },
    

    openModal(evaluation) {
      this.$store.state.qualityManagement.evaluation = evaluation;
      this.openAddEditModal();
    },

    openAddEditModal() {
      this.isAddEditModalActive = true;
    },

    closeAddEditModal() {
      $("#director-area-modal").modal("hide");
      this.isAddEditModalActive = false;
      // this.reSetData();
    },
    submit() {
      let formData = new FormData();
      for (const [key, value] of Object.entries(this.inputs)) {
        formData.append(key, value);
      }
      this.save(formData);
    },

    afterSuccess({ data: { data } }) {
      this.$store.state.evaluatorReview.evalTest = data;
      this.$toastr.s(this.$t("updated_success"));
    },

    afterFinalResponse() {
      this.preloader = false;
    },

    afterError(res) {
      this.$toastr.e(res.data.message);
    },

    openDeleteModal(fileName) {
      this.selected = fileName;
      this.deleteModal = true;
    },

    confirmed() {
      this.inputs[this.selected] = null;
    },

    cancelled() {
      this.deleteModal = false;
    },

    openTab(obj, fileName) {
      const w = window.open(obj[fileName].path, "_blank");
      w.focus();
    },

    loadForm() {
      if (this.$store.state.evaluatorReview.evalTest) {
        this.inputs = {
          accreditationId: this.$store.state.evaluatorReview.accreditationId,
        };
      }
      this.viewFile();
    },

    viewFile()
    {
      let url = `${actions.TECHNICAL_ANALYSIS_REPORT}/decisionDirectorFile/directorTechnicalReport/accreditationData/${this.$store.state.evaluatorReview.accreditationId}`;
      this.axiosGet(url).then((response) => {
        this.inputs = {
          accreditationId: this.$store.state.evaluatorReview.accreditationId,
          director_technical_report: response.data.director_technical_report,
          scope607: response.data.scope607,
          receipt_return_report: response.data.receipt_return_report,
          request_signed: response.data.request_signed,
        };
      });
    }
  },
};
</script>